import React from 'react';
import PropTypes from 'prop-types';
import ImageAnaglyph from './ImageAnaglyph';
import ImagePair from './ImagePair';
import ImageSingle from './ImageSingle';


class Image3d extends React.Component {
    render() {
        const props = this.props;
        if (['optimized', 'dubois', 'grey', 'true', 'color', 'halfcolor'].includes(props.options.type)) {
            return (
                <ImageAnaglyph sources={props.sources} options={props.options}/>
            );
        } else if (['parallel', 'crosseye'].includes(props.options.type)) {
            return (
                <ImagePair sources={props.sources} options={props.options}/>
            );
        } else if (['left', 'right'].includes(props.options.type)) {
            return (
                <ImageSingle sources={props.sources} options={props.options}/>
            );
        }
    }
}

Image3d.propTypes = {
    sources: PropTypes.object,
    options: PropTypes.object
};

export default Image3d;
